import { Controller } from "@hotwired/stimulus";
import Modal from 'bootstrap/js/dist/modal';

// Controller to open a Bootstrap modal and play a Cloudflare Stream video via Shaka
// Works with existing triggers:
// - <a class="video-popup" data-video-id="...">
// - <a data-video-popup="...">
// Optionally support a custom title via data-title
export default class extends Controller {
  connect() {
    this.handleClick = this.handleClick.bind(this);
    // Scope events to this controller's element so we only activate where needed
    this.element.addEventListener('click', this.handleClick, false);
  }

  disconnect() {
    this.element.removeEventListener('click', this.handleClick, false);
  }

  handleClick(event) {
    const target = event.target.closest('[data-video-popup], .video-popup');
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();

    const videoId = target.getAttribute('data-video-popup') || target.getAttribute('data-video-id');
    if (!videoId) return;

    const title = target.getAttribute('data-title') || 'Video';
    const modalHTML = `
      <div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="videoModalLabel">${title}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="ratio ratio-16x9">
                <video
                  id="modal-video-player"
                  controls
                  preload="auto"
                  playsinline
                ></video>
              </div>
            </div>
          </div>
        </div>
      </div>`;

    // Remember element to restore focus to on close
    const returnFocusEl = target;

    // Remove existing modal, then append
    const existing = document.getElementById('videoModal');
    if (existing) existing.remove();
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const modalElement = document.getElementById('videoModal');
    const modal = new Modal(modalElement, {
      backdrop: true,
      keyboard: true,
      focus: true
    });

    // Ensure accessibility: remove aria-hidden on show
    modalElement.addEventListener('show.bs.modal', () => {
      modalElement.removeAttribute('aria-hidden');
    });

    // Before hide: move focus out of the modal to avoid aria-hidden focus warning
    modalElement.addEventListener('hide.bs.modal', () => {
      try {
        if (document.activeElement) document.activeElement.blur();
        (returnFocusEl || document.body).focus({ preventScroll: true });
      } catch (_) {}
    });

    // Clean up on hide (Stimulus video-player#disconnect will destroy Shaka)
    modalElement.addEventListener('hidden.bs.modal', () => {
      modalElement.remove();
    });

    // Initialize Shaka immediately within this click handler (user gesture)
    const video = document.getElementById('modal-video-player');
    const manifestUrl = `https://customer-ikxw003vtz2iah2s.cloudflarestream.com/${videoId}/manifest/video.m3u8?clientBandwidthHint=10.0`;
    const mp4Url = `https://customer-ikxw003vtz2iah2s.cloudflarestream.com/${videoId}/downloads/default.mp4`;
    if (video) {
      import('../../../client/js/common/shaka_player').then(({ initShakaOn }) => {
        // Do not rely on init to autoplay; call play() ourselves under the user gesture
        initShakaOn(video, manifestUrl, mp4Url, { autoplay: false }).then(() => {
          try {
            video.muted = false; // request unmuted playback
            const p = video.play();
            if (p && typeof p.catch === 'function') {
              p.catch(() => {
                // As a last resort, retry muted if the browser still blocks audio
                try {
                  video.muted = true;
                  video.play().catch(() => {});
                } catch (_) {}
              });
            }
          } catch (_) {}
        });
      });
    }

    // Show the modal after starting initialization
    modal.show();
  }
}


